import { render, staticRenderFns } from "./PageWithMainContainer.vue?vue&type=template&id=3e58da28&scoped=true&"
import script from "./PageWithMainContainer.vue?vue&type=script&lang=ts&"
export * from "./PageWithMainContainer.vue?vue&type=script&lang=ts&"
import style0 from "./PageWithMainContainer.vue?vue&type=style&index=0&id=3e58da28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58da28",
  null
  
)

export default component.exports